import { render, staticRenderFns } from "./pending-table.vue?vue&type=template&id=d2a38996"
import script from "./pending-table.vue?vue&type=script&lang=js"
export * from "./pending-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports